import BackdropLoading from 'components/common/BackdropLoading';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';

import { useUserAuth } from 'hooks/useUserAuth';

const NotFound = () => {
  const { status, isAuthenticated } = useUserAuth();
  const { t } = useTranslation();

  if (status === 'loading') {
    return <BackdropLoading open loadingText={t('common:loading')} />;
  }

  return <Redirect to={isAuthenticated ? '/orders' : '/sign-in'} />;
};

export default NotFound;
